<app-activity-timeslot-list
  [activity]="activity"
  [hasSeeMoreUrl]="hasSeeMoreUrl"
  [seeMoreUrl]="'organizer.activity.dates' | localize"
  [timeslots]="timeslots"
  [timeslotVariant]="timeslotVariant"
  [hasPagination]="hasPagination"
  [hasLoadMoreButton]="hasLoadMoreButton"
  (loadMore)="loadMore.emit()"
>
  <ng-container *ngFor="let timeslot of timeslots">
    <button
      *appListItem
      cta
      app-vtmn-play-button
      type="button"
      [type]="ctaButtonType.Button"
      [size]="vtmnPlayButtonSize.SMALL"
      class="ml-auto"
      (click)="handleClick(timeslot)"
    >
      {{ 'organizer.manage_activity.coming_timeslots.see.button' | translate }}
    </button>
  </ng-container>
</app-activity-timeslot-list>
